// extracted by mini-css-extract-plugin
export default {"subscript":"_ojhUxKWGyFdJIV2Lodx","bg":"ZmbOmk0ieSKOdeIimJCA","gou":"orcE9bnrEF9xDTLnxVZg","common_bganimation":"_TiWrFu0Gxx_V2tfwTr7"};